import axiosInstance from './axiosInstance';

export const getTeachers = async (params?: {
  page?: number;
  limit?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}) => {
  const response = await axiosInstance.get('/teachers', { params });
  return response.data;
};

export const getTeacher = async (id: string) => {
  const response = await axiosInstance.get(`/teachers/${id}`);
  return response.data;
};

export const addTeacher = async (teacherData: { name: string; level?: string; instanceId?: number }) => {
  const response = await axiosInstance.post('/teachers', teacherData);
  return response.data;
};

export const updateTeacher = async (id: string, teacherData: any) => {
  const response = await axiosInstance.put(`/teachers/${id}`, teacherData);
  return response.data;
};

export const deleteTeacher = async (id: string) => {
  const response = await axiosInstance.delete(`/teachers/${id}`);
  return response.data;
};

export const getAssignableSubjects = async () => {
  const response = await axiosInstance.get('/teachers/assignable-subjects');
  return response.data;
};